import React from 'react';
import {Input} from 'reactstrap';
import '../../../styles/layout/forms/TextInput.css'

const TextInput = ({ id, value, label,onChange }) => {
    

    return (  
        <div className="theme-input">
            <label>{label}</label>        
            <Input                
                id={id}
                type="text"
                value={value}
                onChange={onChange}
            />
        </div>
    );
}
export default TextInput
